import React from "react";
import { Box, Typography, Card, CardContent } from "@material-ui/core";

const clients = [
  { name: "Future Leaders School" },
  { name: "Discovery Learning Center" },
  { name: "Harmony Montessori" },
  { name: "Bright Minds School" },
  { name: "New Horizon School" },
  { name: "Little Stars Academy" },
];

export default function OurClients() {
  // Duplicate for seamless scroll
  const scrollingClients = [...clients, ...clients];

  return (
    <Box py={6} bgcolor="#fff" textAlign="center">
      <Typography variant="h4" gutterBottom>
        Our Montestory Community
      </Typography>
      <Typography variant="subtitle1" color="textSecondary">
        Trusted by leading Montessori schools worldwide
      </Typography>

      {/* Scrolling container */}
      <Box
        mt={4}
        overflow="hidden"
        position="relative"
        width="100%"
        style={{ whiteSpace: "nowrap" }}
        padding="7px"
        
    
      >
        <Box
          display="inline-block"
          style={{
            animation: "scrollLeft 25s linear infinite",
            display: "flex",
          }}
        >
          {scrollingClients.map((client, index) => (
            <Card
              key={index}
              style={{
                width: 240,
                margin: "0 12px",
                borderRadius: 12,
                flexShrink: 0,
                backgroundColor:"aliceblue"
              }}
            >
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>
                  {client.name}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>

      {/* Stats */}
      <Box mt={6} display="flex" justifyContent="center" flexWrap="wrap">
        <StatBox label="Schools Served" value="15+" color="#007bff" />
        <StatBox label="Active Students" value="1000" color="#28a745" />
        <StatBox label="Teachers" value="100" color="#fd7e14" />
        <StatBox label="Satisfaction" value="100%" color="#007bff" />
      </Box>

      {/* CSS keyframe animation */}
      <style>
        {`
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </Box>
  );
}

function StatBox({ label, value, color }) {
  return (
    <Box textAlign="center" mx={4} my={2}>
      <Typography variant="h6" style={{ color, fontWeight: 600 }}>
        {value}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
    </Box>
  );
}
